var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "site_breadcumb_wrapper",
      class: [_vm.breadCrumbClasses, _vm.isStyled ? "styled_site_crumb" : ""],
    },
    [
      _vm.isBreadcrumbsExist
        ? _c(
            "ul",
            { staticClass: "site_breadcumb_ul", class: _vm.listStyles },
            [
              _vm._l(_vm.breadcrumbs, function (breadcrumb, index) {
                return _c(
                  "li",
                  {
                    key: breadcrumb.title,
                    staticClass: "flex font-semibold breadcrumb_item",
                    class: [
                      _vm.isProjectsPage,
                      breadcrumb.classes ? `${breadcrumb.classes}_li` : "",
                      index == _vm.breadcrumbs.length - 1
                        ? "crumb_last_item w-full"
                        : "",
                    ],
                  },
                  [
                    breadcrumb.icon
                      ? _c("NavigationIcon", {
                          staticClass: "mr-3 self-center",
                          attrs: {
                            shownIconComponentName: breadcrumb.icon,
                            iconSizeClasses: _vm.getIconSizeClasses(
                              breadcrumb.icon
                            ),
                          },
                        })
                      : _vm._e(),
                    _vm.isLinkShown(index)
                      ? _c(
                          "span",
                          {
                            staticClass: "flex items-center crumb_item_content",
                          },
                          [
                            _c(
                              "RouterLink",
                              {
                                staticClass: "hover:text-primary-500 w-max",
                                attrs: {
                                  to: breadcrumb.routeQuery
                                    ? {
                                        name: breadcrumb.routeName,
                                        query: breadcrumb.routeQuery,
                                      }
                                    : { name: breadcrumb.routeName },
                                },
                              },
                              [_vm._v(" " + _vm._s(breadcrumb.title) + " ")]
                            ),
                            _c("AngleIcon", { staticClass: "mx-2" }),
                          ],
                          1
                        )
                      : _c(
                          "span",
                          {
                            staticClass:
                              "not_link_breadcrumb crumb_item_content",
                            class: {
                              "font-semibold": true,
                              "w-max-content": true,
                            },
                          },
                          [_vm._v(" " + _vm._s(breadcrumb.title) + " ")]
                        ),
                    breadcrumb.innerComponent
                      ? _c(
                          "span",
                          { staticClass: "ml-2" },
                          [
                            _c(
                              breadcrumb.innerComponent.name,
                              _vm._b(
                                { tag: "component" },
                                "component",
                                breadcrumb.innerComponent.props,
                                false
                              )
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.isCopyButtonShown(index, breadcrumb)
                      ? _c("ShareUrlButton", {
                          staticClass: "ml-2",
                          attrs: { copyCurrentUrl: "", makeInline: "" },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              }),
              _c("li", [
                _vm._v(
                  "                                                                                                                 "
                ),
              ]),
            ],
            2
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }